import Vue from 'vue'
import Router from 'vue-router'

//片方底部导航
const studioFooter = resolve => require(['../components/common/studio_footer.vue'], resolve);
//影院方底部导航
const cinemaFooter = resolve => require(['../components/common/cinema_footer.vue'], resolve); 
//影投项目底部导航
const filmInvestFooter = resolve => require(['../components/common/film_invest_footer.vue'], resolve);
//影投影片资源库底部导航
const flimBaseFooter = resolve => require(['../components/common/film_base_footer.vue'], resolve);
Vue.use(Router)

export default new Router({
  // mode: 'history',
  linkActiveClass: 'tab-active',
  routes: [
    {
      path: '/',
      redirect:'/studio/taskList',
      name:'home'
    },
    {
      path: '/bill/billReconciliation',
      name: 'billReconciliation',
      meta: {
        title: '账单对账'
      },
      components:{
        default: resolve => require(['../components/page/bill/bill_reconciliation.vue'], resolve),
      }
    },
    {
      path: '/studio/taskList',
      name: 'studioTaskList',
      meta: {
        title: '任务列表'
      },
      components:{
        default: resolve => require(['../components/page/studio/task_list.vue'], resolve),
        studioFooter: studioFooter
      }
    },
    {
      path: '/studio/studioFilmDetails',
      name: 'studioFilmDetails',
      meta: {
        title: '影片详情'
      },
      components:{
        default: resolve => require(['../components/page/studio/film_details.vue'], resolve),
      }
    },
    {
      path: '/studio/studioTaskDetails',
      name: 'studioTaskDetails',
      meta: {
        title: '任务详情'
      },
      components:{
        default: resolve => require(['../components/page/studio/task_details.vue'], resolve),
      }
    },
    {
      path: '/studio/studioTweetsTip',
      name: 'studioTweetsTip',
      meta: {
        title: '发布流程'
      },
      components:{
        default: resolve => require(['../components/page/studio/studio_tweets_tip.vue'], resolve),
      }
    },
    {
      path: '/studio/studioTweetsTaskDetails',
      name: 'studioTweetsTaskDetails',
      meta: {
        title: '推文详情'
      },
      components:{
        default: resolve => require(['../components/page/studio/tweets_task_details.vue'], resolve),
      }
    },
    {
      path: '/studio/user',
      name: 'studioUser',
      meta: {
        title: '个人中心'
      },
      components:{
        default: resolve => require(['../components/page/studio/user.vue'], resolve),
        studioFooter: studioFooter
      }
    },
    {
      path: '/studio/city',
      name: 'studioCity',
      meta: {
        title: '城市管理'
      },
      component:resolve => require(['../components/page/studio/city.vue'], resolve)
    },
    {
      path: '/studio/cityManage',
      name: 'studioCityManage',
      meta: {
        title: '城市管理'
      },
      component:resolve => require(['../components/page/studio/city_manage.vue'], resolve)
    },
    {
      path: '/studio/taskAdd',
      name: 'taskAdd',
      meta: {
        title: '排片任务'
      },
      component: resolve => require(['../components/page/studio/task_add.vue'], resolve)
    },
    {
      path: '/studio/taskForwardAdd',
      name: 'taskForwardAdd',
      meta: {
        title: '转发任务'
      },
      component: resolve => require(['../components/page/studio/task_forward_add.vue'], resolve)
    },
    {
      path: '/studio/studioPerfectInfor',
      name: 'studioPerfectInfor',
      meta: {
        title: '完善个人信息'
      },
      component: resolve => require(['../components/page/studio/perfect_infor.vue'], resolve)
    },
    {
      path: '/studio/studioUserInfor',
      name: 'studioUserInfor',
      meta: {
        title: '我的信息'
      },
      component: resolve => require(['../components/page/studio/user_infor.vue'], resolve)
    },
    {
      path: '/studio/studioAmountDetails',
      name: 'studioAmountDetails',
      meta: {
        title: '账户明细'
      },
      component: resolve => require(['../components/page/studio/amount_details.vue'], resolve)
    },
    {
      path: '/studio/studioSignExamine',
      name: 'studioSignExamine',
      meta: {
        title: '审核上报信息'
      },
      component: resolve => require(['../components/page/studio/sign_examine.vue'], resolve)
    },
    {
      path: '/studio/studioTweetsExamine',
      name: 'studioTweetsExamine',
      meta: {
        title: '审核转载信息'
      },
      component: resolve => require(['../components/page/studio/tweets_examine.vue'], resolve)
    },
    {
      path: '/studio/studioTransferExamine',
      name: 'studioTransferExamine',
      meta: {
        title: '已转账详情信息'
      },
      component: resolve => require(['../components/page/studio/transfer_examine.vue'], resolve)
    },
    {
      path: '/studio/releaseTaskDetails',
      name: 'releaseTaskDetails',
      meta: {
        title: '转发任务详情'
      },
      component: resolve => require(['../components/page/studio/release_task_details.vue'], resolve)
    },
    {
      path: '/studio/taskMaterielAdd',
      name: 'taskMaterielAdd',
      meta: {
        title: '新建物料任务'
      },
      component: resolve => require(['../components/page/studio/task_materiel_add.vue'], resolve)
    },
    {
      path: '/studio/taskMaterielDetails',
      name: 'taskMaterielDetails',
      meta: {
        title: '物料任务详情'
      },
      component: resolve => require(['../components/page/studio/task_materiel_details.vue'], resolve)
    },
    {
        path: '/studio/releasedMaterielDetails',
        name: 'releasedMaterielDetails',
        meta: {
          title: '物料任务详情'
        },
        component: resolve => require(['../components/page/studio/released_materiel_details.vue'], resolve)
    },
    {
      path: '/studio/examineMaterielDetails',
      name: 'examineMaterielDetails',
      meta: {
        title: '物料任务审核'
      },
      component: resolve => require(['../components/page/studio/examine_materiel_details.vue'], resolve)
    },
    {
      path: '/studio/examineMaterielUp',
      name: 'examineMaterielUp',
      meta: {
        title: '物料上传审核'
      },
      component: resolve => require(['../components/page/studio/examine_materiel_up.vue'], resolve)
    },
    {
      path: '/cinema/taskList',
      name: 'cinemaTaskList',
      meta: {
        title: '影院任务列表'
      },
      components:{
        default: resolve => require(['../components/page/cinema/task_list.vue'], resolve),
        studioFooter: cinemaFooter
      }
    },
    {
      path: '/cinema/user',
      name: 'cinemaUser',
      meta: {
        title: '影院个人中心'
      },
      components:{
        default: resolve => require(['../components/page/cinema/user.vue'], resolve),
        studioFooter: cinemaFooter
      }
    },
    {
      path: '/cinema/taskDetails',
      name: 'cinemaTaskDetails',
      meta: {
        title: '任务详情'
      },
      components:{
        default: resolve => require(['../components/page/cinema/task_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/tweetsTaskList',
      name: 'tweetsTaskList',
      meta: {
        title: '转载任务'
      },
      components:{
        default: resolve => require(['../components/page/cinema/tweets_task_list.vue'], resolve),
        studioFooter: cinemaFooter
      }
    },
    {
      path: '/cinema/cinemaTweetsDetails',
      name: 'cinemaTweetsDetails',
      meta: {
        title: '转载任务详情'
      },
      components:{
        default: resolve => require(['../components/page/cinema/tweets_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaMyTweetsDetails',
      name: 'cinemaMyTweetsDetails',
      meta: {
        title: '我的转载任务详情'
      },
      components:{
        default: resolve => require(['../components/page/cinema/my_tweets_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/amountDetails',
      name: 'amountDetails',
      meta: {
        title: '收款总金额'
      },
      components:{
        default: resolve => require(['../components/page/cinema/amount_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaIdentity',
      name: 'cinemaIdentity',
      meta: {
        title: '身份选择'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_identity.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaUpload',
      name: 'cinemaUpload',
      meta: {
        title: '上传资料'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_upload.vue'], resolve),
      }
    },
    {
      path: '/cinema/userInfor',
      name: 'userInfor',
      meta: {
        title: '影院基础信息'
      },
      components:{
        default: resolve => require(['../components/page/cinema/user_infor.vue'], resolve),
      }
    },
    {
      path: '/cinema/userAccountInfor',
      name: 'userAccountInfor',
      meta: {
        title: '公众号信息'
      },
      components:{
        default: resolve => require(['../components/page/cinema/user_account_infor.vue'], resolve),
      }
    },
    {
      path: '/cinema/cooperationCinemaSign',
      name: 'cooperationCinemaSign',
      meta: {
        title: '填写影院信息'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cooperation_cinema_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/nextCooperationCinemaSign',
      name: 'nextCooperationCinemaSign',
      meta: {
        title: '填写影院信息'
      },
      components:{
        default: resolve => require(['../components/page/cinema/next_cooperation_cinema_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/unCooperationCinemaSign',
      name: 'unCooperationCinemaSign',
      meta: {
        title: '非合作影院工作人员'
      },
      components:{
        default: resolve => require(['../components/page/cinema/unCooperation_cinema_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/unCooperationPersonalSign',
      name: 'unCooperationPersonalSign',
      meta: {
        title: '非影院工作人员'
      },
      components:{
        default: resolve => require(['../components/page/cinema/unCooperation_personal_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/nextCooperationTweetsSign',
      name: 'nextCooperationTweetsSign',
      meta: {
        title: '填写影院信息'
      },
      components:{
        default: resolve => require(['../components/page/cinema/next_cooperation_tweets_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/unCooperationTweetsCinemaSign',
      name: 'unCooperationTweetsCinemaSign',
      meta: {
        title: '非合作影院工作人员'
      },
      components:{
        default: resolve => require(['../components/page/cinema/unCooperation_tweets_cinema_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/unCooperationTweetsPersonalSign',
      name: 'unCooperationTweetsPersonalSign',
      meta: {
        title: '非影院工作人员'
      },
      components:{
        default: resolve => require(['../components/page/cinema/unCooperation_tweets_personal_sign.vue'], resolve),
      }
    },
    {
      path: '/cinema/studioExample',
      name: 'studioExample',
      meta: {
        title: '成为片方'
      },
      components:{
        default: resolve => require(['../components/page/cinema/studio_example.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaMateriel',
      name: 'cinemaMateriel',
      meta: {
        title: '物料任务'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_materiel.vue'], resolve),
        studioFooter: cinemaFooter
      }
    },
    {
      path: '/cinema/cinemaMaterielDetails',
      name: 'cinemaMaterielDetails',
      meta: {
        title: '物料任务详情'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_materiel_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaMyMaterielDetails',
      name: 'cinemaMyMaterielDetails',
      meta: {
        title: '物料任务详情'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_my_materiel_details.vue'], resolve),
      }
    },
    {
      path: '/cinema/cinemaMaterielUpload',
      name: 'cinemaMaterielUpload',
      meta: {
        title: '物料上传'
      },
      components:{
        default: resolve => require(['../components/page/cinema/cinema_materiel_upload.vue'], resolve),
      }
    },

    {
      path: '/filmInvest/filmInvestSystem',
      name: 'filmInvestSystem',
      meta: {
        title: '影片投资系统'
      },
      components:{
        default: resolve => require(['./../components/page/filmInvest/film_invest_system.vue'], resolve)
      }
    },
    {
      path: '/filmInvest/filmPerformer',
      name: 'filmPerformer',
      meta: {
        title: '影人资源库',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_performer.vue'], resolve),
        studioFooter: flimBaseFooter
      }
    },
    {
      path: '/filmInvest/filmPerformerDetail',
      name: 'filmPerformerDetail',
      meta: {
        title: '影人详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_performer_detail.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/filmCompany',
      name: 'filmCompany',
      meta: {
        title: '公司资源库',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_company.vue'], resolve),
        studioFooter: flimBaseFooter
      }
    },
    {
      path: '/filmInvest/filmCompanyDetail',
      name: 'filmCompanyDetail',
      meta: {
        title: '公司详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_company_detail.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/filmList',
      name: 'filmList',
      meta: {
        title: '影片资源库',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_list.vue'], resolve),
        studioFooter: flimBaseFooter
      }
    },
    {
      path: '/filmInvest/filmDetail',
      name: 'filmDetail',
      meta: {
        title: '影片详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_detail.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/filmCompanyAll',
      name: 'filmCompanyAll',
      meta: {
        title: '参与公司'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_company_all.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/filmPerformerAll',
      name: 'filmPerformerAll',
      meta: {
        title: '演职人员'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/film_performer_all.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investList',
      name: 'investList',
      meta: {
        title: '项目投资管理',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_list.vue'], resolve),
        studioFooter:filmInvestFooter
      }
    },
    {
      path: '/filmInvest/investDetails',
      name: 'investDetails',
      meta: {
        title: '项目详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_details.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investResult',
      name: 'investResult',
      meta: {
        title: '提交结果'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_result.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investScore',
      name: 'investScore',
      meta: {
        title: '参与评分'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_score.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investScorePost',
      name: 'investScorePost',
      meta: {
        title: '参与评分'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_score_post.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investPersonnel',
      name: 'investPersonnel',
      meta: {
        title: '评分结果'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_personnel.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investScoreDetail',
      name: 'investScoreDetail',
      meta: {
        title: '评分详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_score_detail.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investSuccess',
      name: 'investSuccess',
      meta: {
        title: '成功页'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_success.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/reviewInvestList',
      name: 'reviewInvestList',
      meta: {
        title: '复审资料'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/review_invest_list.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investContractNode',
      name: 'investContractNode',
      meta: {
        title: '投资合同节点'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_contract_node.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investFristDetails',
      name: 'investFristDetails',
      meta: {
        title: '诉讼一审详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_frist_details.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investMonthlyReport',
      name: 'investMonthlyReport',
      meta: {
        title: '项目月报'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_monthly_report.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investMonthlyReportAdd',
      name: 'investMonthlyReportAdd',
      meta: {
        title: '新增月报'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_monthly_report_add.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investMonthlyReportDetails',
      name: 'investMonthlyReportDetails',
      meta: {
        title: '月报详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_monthly_report_details.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investSeekOpinions',
      name: 'investSeekOpinions',
      meta: {
        title: '征求意见'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_seek_opinions.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investExecutionRecord',
      name: 'investExecutionRecord',
      meta: {
        title: '执行记录',
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_execution_record.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investConsumerList',
      name: 'investConsumerList',
      meta: {
        title: '客户管理',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_consumer_list.vue'], resolve),
        studioFooter:filmInvestFooter
      }
    },
    {
      path: '/filmInvest/consumerDetail',
      name: 'consumerDetail',
      meta: {
        title: '公司信息'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/consumer_detail.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investContractList',
      name: 'investContractList',
      meta: {
        title: '合同管理',
        keepAlive: true
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_contract_list.vue'], resolve),
        studioFooter:filmInvestFooter
      }
    },
    {
      path: '/filmInvest/investContractDetails',
      name: 'investContractDetails',
      meta: {
        title: '合同详情'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_contract_details.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/relationContractList',
      name: 'relationContractList',
      meta: {
        title: '关联合同列表'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/relation_contract_list.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/meetingNotifyVerify',
      name: 'meetingNotifyVerify', 
      meta: {
        title: '纪要确认通知',
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/meeting_notify_verify.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/notificationResults',
      name: 'notificationResults', 
      meta: {
        title: '通知结果'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/notification_results.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investPictureList',
      name: 'investPictureList',
      meta: {
        title: '查看图片列表'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_picture_list.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investItemInfor',
      name: 'investItemInfor',
      meta: {
        title: '查看项目资料'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_item_infor.vue'], resolve),
      }
    },
    {
      path: '/filmInvest/investContractSigningList',
      name: 'investContractSigningList',
      meta: {
        title: '合同签约列表'
      },
      components:{
        default: resolve => require(['../components/page/filmInvest/invest_contract_signing_list.vue'], resolve),
      }
    },
    {
      path: '/gzh/writeOff',
      name: 'writeOff',
      meta: {
        title: '核销'
      },
      components:{
        default: resolve => require(['../components/page/gzh/write_off.vue'], resolve),
      }
    },
    {
      path: '/gzh/writeOff',
      name: 'writeOff',
      meta: {
        title: '核销'
      },
      components:{
        default: resolve => require(['../components/page/gzh/write_off.vue'], resolve),
      }
    },
    {
      path: '/cm/bindWechatCheckPhone',
      name: 'bindWechatCheckPhone',
      meta: {
        title: '身份校验'
      },
      components:{
        default: resolve => require(['../components/page/cm/check_phone.vue'], resolve),
      }
    },
    {
      path: '/testPage',
      name: 'testPage',
      meta: {
        title: '测试页面'
      },
      components:{
        default: resolve => require(['../components/test.vue'], resolve),
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js